/**
 * Static data + content constants for the /free-screening page.
 * Extracted from FreeScreening.jsx so the page component is just
 * orchestration. Keeping all consumer JSX in `components/` makes
 * it easy to swap or A/B-test individual lists without touching
 * the main page file.
 */
import {
  Sparkles, HeartHandshake, MessageCircle, Brain, Activity,
  Hand, PenLine, GraduationCap, Footprints, Users, Frown, Ear,
  Stethoscope, Award,
} from "lucide-react";

export const WHATSAPP_NUMBER = "918877353514";

export const DR_PHOTO =
  "https://kiddoplus.com/assets/images/dr-dipak.png";

export const YT_VIDEO_ID = "Jm1BTI-CF6Y";

export const CONCERNS = [
  { icon: MessageCircle, text: "Delayed speech or communication" },
  { icon: Activity, text: "Poor attention or hyperactivity" },
  { icon: Brain, text: "Difficulty following instructions" },
  { icon: Ear, text: "Sensory sensitivities" },
  { icon: Frown, text: "Frequent meltdowns" },
  { icon: Users, text: "Social interaction difficulties" },
  { icon: Hand, text: "Fine motor difficulties" },
  { icon: PenLine, text: "Handwriting concerns" },
  { icon: GraduationCap, text: "Learning challenges" },
  { icon: Footprints, text: "Balance or coordination issues" },
  { icon: Sparkles, text: "Toe walking" },
  { icon: HeartHandshake, text: "Delayed independence skills" },
];

export const FAQS = [
  { q: "Is the screening free?", a: "Yes, the initial developmental screening is completely free." },
  { q: "What age group do you support?", a: "Children aged 3-12 years." },
  { q: "Will I receive therapy?", a: "This screening helps identify concerns and provides guidance on possible next steps." },
  { q: "Is my information secure?", a: "Yes, your information is stored securely and used only for screening purposes." },
];

export const TESTIMONIALS = [
  { name: "Aarav\u2019s Mother",   quote: "Dr. Dipak patiently listened to our concerns and explained our child\u2019s strengths and areas that needed support. The guidance was practical and easy to follow." },
  { name: "Riya\u2019s Father",    quote: "The screening process was simple, and we received helpful suggestions that we could start using at home right away." },
  { name: "Vivaan\u2019s Parents", quote: "We appreciated the clear explanation and personalized recommendations. It gave us confidence about the next steps." },
  { name: "Anaya\u2019s Mother",   quote: "The consultation helped us understand our daughter\u2019s developmental needs much better. We left with a clear action plan." },
  { name: "Ishaan\u2019s Father",  quote: "The advice was practical, professional, and focused on our child\u2019s individual needs. Thank you for the guidance." },
  { name: "Kiara\u2019s Parents",  quote: "We were worried about our child\u2019s attention and communication. The screening gave us valuable direction on what to work on at home." },
  { name: "Advik\u2019s Mother",   quote: "The recommendations were easy to understand and fit naturally into our daily routine. We noticed positive changes after following them consistently." },
  { name: "Myra\u2019s Parents",   quote: "We finally felt heard. The screening helped us understand our child\u2019s challenges and what steps to take next." },
];

export const AVATAR_COLORS = [
  "from-[#14B8A6]/40 to-[#F4C430]/40",
  "from-[#F4C430]/40 to-[#14B8A6]/30",
  "from-[#2F6F6A]/30 to-[#14B8A6]/30",
  "from-[#14B8A6]/30 to-[#2F6F6A]/40",
];

export const CREDENTIALS = [
  { icon: GraduationCap, label: "Bachelor's in OT",    value: "SVNIRTAR, Cuttack · Odisha" },
  { icon: GraduationCap, label: "Master's in OT",      value: "Vivekananda Global University" },
  { icon: Stethoscope,   label: "Sensory Integration", value: "Certified, CLASI · USA" },
  { icon: Award,         label: "OPT™ Level 2",        value: "TalkTools · USA" },
  { icon: HeartHandshake,label: "4+ Years Experience", value: "Hospitals · Clinics · Schools" },
  { icon: Users,         label: "Co-founder & Instructor", value: "Trained 1300+ Parents" },
];

export const URGENCY_KEYS = {
  deadline: "kp_urg_deadline_v1",
  cycle:    "kp_urg_cycle_v1",
  slots:    "kp_urg_slots_v1",
  slotsDay: "kp_urg_slots_day_v1",
};

export const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

export const stagger = {
  hidden: {},
  show:   { transition: { staggerChildren: 0.07 } },
};
